import React, { useState } from 'react';
import Button from 'button';
import Img from 'img';
import Icon from 'icon';
import Headline from 'headline';
import Container from 'container';
import s from './dynamic_image_text.module.scss';

export default function Ada({
  headline,
  services,
  services_buttons,
  bold_text,
  ...props
}) {
  const [content, setContent] = useState(0);
  return (
    <Container className={s.root}>
      <Headline className={s.headline} h1 html={headline} />
      {services.map(({ image, title, text }, i) => {
        return content === i ? (
          <div className={s.serviceWrapper} key={image.title}>
            <div className={s.imgWrapper}>
              <Img className={s.img} src={image} alt={image.title} />
            </div>
            <div className={s.textWrapper}>
              <Headline className={s.title} html={title} />
              <p className={s.infoText} dangerouslySetInnerHTML={{ __html: text }} />
            </div>
          </div>
        ) : null;
      })}
      <div className={s.buttonsWrapper}>
        {services.map(({ button }, i) => (
          <div className={s.buttonWrapper} key={button.text}>
            <Button
              onClick={() => setContent(i)}
              className={`${s.service_button} ${i === content && s.focus}`}
            >
              {button.text}
            </Button>
            <Icon className={s.icon} icon="arrow-right" />
            <div className={s.separator} />
          </div>
        ))}
      </div>

      <p dangerouslySetInnerHTML={{ __html: bold_text }} />
    </Container>
  );
}
